import { Select, Typography } from "antd";

export const ChangeLanguage = () => {
  return (
    <>
      <i className="fa-solid fa-globe" style={{ marginRight: 5 }} />
      <Select defaultValue="en" variant="borderless">
        <Select.Option value="en">
          <Typography.Text strong>English</Typography.Text>
        </Select.Option>
      </Select>
    </>
  );
};
